/* global app, existingGroups */

app.controller('dialog_editPositionCtrl', ['$rootScope', '$scope', '$http', 'NetworkService','AtlasNotification','AtlasDialog', function ($rootScope, $scope, $http, NetworkService, AtlasNotification, AtlasDialog) {
        $scope.gui = {okButtonDisabled:true};
        $scope.position = {};
        $scope.editLanguage = "de";
        $scope.editors = {};
        
        $rootScope.$on("editPositionDialog", function(e,data){
            $scope.position = data
            gui.setTextFieldContent("positiondescription", data.alle_positionen_text)
            gui.setTextFieldContent("positiondescriptionEn", data.alle_positionen_text_en)
            $scope._loadGroupData()
        })
        
        
       
        $rootScope.$on("ACDataTable:groupPositionPermissionTable:finished", function(){
            $scope.dataTables.groupPositionPermissionTable.saveEntry = function(phantomData){
                alert();
                var data = {
                    eventId: event.Veranstaltungsnummer,
                    permissionLevel: phantomData.Stufe,
                    groupId: phantomData.Gruppenname.groupId,
                    positionId: $scope.position.alle_positionen_id
                }
                NetworkService.callOperation("addGroupPermissionToPosition", data, function(response){
                    if(response.isSuccessfull()){
                        AtlasNotification.info("Berechtigung wurde erfolgreich hinzugefügt.");
                    }
                    //NetworkService.callOperation("reload/group/"+$scope.group.groupId, {}, function(response){
                    //    $scope.groupPermissions = response.get("groupPermissions");
                    //})
                })
            }
            
            $scope.dataTables.groupPositionPermissionTable.removeEntry = function(selectedIds){
                    selectedIds.forEach(function(selectedId){
                        var permission = $scope.groupPermissions[selectedId];
                        var data = {
                            eventId: event.Veranstaltungsnummer,
                            groupId: permission.groupId,
                            positionId: $scope.position.alle_positionen_id 
                        };
                        
                        NetworkService.callOperation("removeGroupPermissionFromPosition", data, function(response){
                            if(response.isSuccessfull()){
                                AtlasNotification.info("Berechtigung wurde erfolgreich gelöscht.");
                                $scope._loadGroupData()
                            }
                        })
                    })
 

                   
                }
        
        
        })
        
        $scope._loadGroupData = function(){
            var data = {
                eventId: event.Veranstaltungsnummer,
                positionId: $scope.position.alle_positionen_id
            }
            NetworkService.callOperation("getGroupPermissionsForPosition", data, function(response) {
                //$scope.positionGroups = response.get("groups");
                $scope.groupPermissions = response.get("groups");
                $scope.existingGroups = existingGroups;
                $rootScope.$emit("ACDataTable:groupPositionPermissionTable:newData")
            })
        }
        
        /*$scope.addNewGroup = function(selectedGroup, selectedPermissionLevel){
            var data = {
                groupId: selectedGroup.groupId,
                permissionLevel: selectedPermissionLevel,
                eventId: event.Veranstaltungsnummer,
                positionId: $scope.position.alle_positionen_id
            }

            NetworkService.callOperation("addGroupPermissionToPosition", data, function(response) {
                if(response.isSuccessfull()){
                    AtlasNotification.info("Berechtigung wurde erfolgreich hinzugefügt");
                    $scope._loadGroupData();
                }
            })
        }
        */
        
        $scope.removeGroup = function(group){
            var data = {
                groupId: group.groupId,
                eventId: event.Veranstaltungsnummer,
                positionId: $scope.position.alle_positionen_id
            }
            
            NetworkService.callOperation("removeGroupPermissionFromPosition", data, function(response) {
                if(response.isSuccessfull()){
                    AtlasNotification.info("Berechtigung wurde erfolgreich gelöscht");
                    $scope._loadGroupData();
                }
            })
        }
        
        
        $scope.generateList = function(){
            window.open('/getPositionList/'+$scope.position.alle_positionen_id, '_blank');
        }
        
        $scope.hasValue = function(model){
            return model != undefined && model != "";
        }
        $scope.formChanged = function(){
            $scope.gui.okButtonDisabled = false;
            if($scope.hasValue($scope.event.Veranstaltungsname) && $scope.hasValue($scope.event.Startzeit) && $scope.hasValue($scope.event.Endzeit) && $scope.hasValue($scope.event.Veranstaltungsort)){
                //$scope.gui.okButtonDisabled = false;
            }
        }
        
        $scope.switchLanguage = function(){
            if($scope.editLanguage == "en"){
                $scope.editLanguage = "de"
            }else{
                $scope.editLanguage = "en";
            }
        }
        
        $scope.deletePosition = function(){
            AtlasDialog.yesNo("Position sicher löschen?", function(){
               NetworkService.callOperation("deletePosition", {positionId: $scope.position.alle_positionen_id}, function(data, meta){
                        AtlasNotification.info("Position erfolgreich gelöscht.");
                        $scope.updateCalendar();
                    })
                }, function(){
                console.log("nein")
            })
        }
        
        $scope.updatePosition = function ()
        {
            var newPosition = {
                name: $scope.position.alle_positionen_description,
                description: $scope.position.alle_positionen_text,
                needs_approval: $scope.position.needs_approval,
                positionId: $scope.position.alle_positionen_id,
                name_en: $scope.position.alle_positionen_description_en,
                description_en: $scope.position.alle_positionen_text_en,
            };
            
            NetworkService.callOperation("updateposition", newPosition, function(response){
                if(response.isSuccessfull()){
                    AtlasNotification.info("Position erfolgreich upgedatet.");
                }
            })
        }
    }])